export const SocialIcons = () => {
  return (
    <div className='d-flex justify-content-between mt-5' style={{maxWidth: '180px', margin: 'auto'}}>
      <a href="https://www.facebook.com/sepidartheaterkollektiv/" target="_blank" title='Follow us on Facebook'>
        <i className="bi bi-facebook text-light fs-1"></i>
      </a>
      <a href="https://www.instagram.com/sepidar__theater/" target="_blank" title='Follow us on Instagram'>
        <i className="bi bi-instagram text-light fs-1"></i>
      </a>
      <a href="https://www.youtube.com/@sepidartheater1258" target="_blank" title='Subscribe to our YouTube channel'>
        <i className="bi bi-youtube text-light fs-1"></i>
      </a>
    </div>
  );
};

